import React, { useState } from 'react';
import Button from '~~elements/Button';
import Multilingual from '~~utils/Multilingual';
import { SectionDiv } from '../styled';
import styled from 'styled-components';
import TeamModal from './TeamModal';
import CreateTeamModal from './CreateTeamModal';
import ImportTeamModal from './ImportTeamModal';

const StyledDiv = styled.div`
  width: 100%;
  .teams-panel {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;

    &--start {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: flex-start;
      > * {
        margin-right: 0.5rem;
      }
    }
    &--end {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: flex-end;
      > * {
        margin-left: 0.5rem;
      }
    }
  }

  .team-list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, 10rem);
    gap: 0.5rem;
    justify-content: center;
    border-top: 1px solid #ddd;
    padding: 0.5rem 0 0;
  }
  .team {
    padding: 0.5rem 0.3rem;
    border-radius: 5px;
    border: 1px solid #eee;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 0.9rem;
    cursor: pointer;
  }
`;

const getModalTeamInitState = () => {
  return {
    name: '',
    origin: { city: '', icon_url: '', name: '', uniqid: '' },
    season: { title: '', uniqid: '' },
  };
};

const Teams = ({ teams }) => {
  const [isTeamImporting, setTeamImporting] = useState(false);
  const [isTeamCreating, setTeamCreating] = useState(false);

  const [selectedTeam, setSelectedTeam] = useState('');
  const [modalTeam, setModalTeam] = useState(getModalTeamInitState());

  const openTeamImportModal = (toOpen) => () => {
    setTeamImporting(toOpen);
  };

  const openTeamCreateModal = (toOpen) => () => {
    setTeamCreating(toOpen);
  };

  const handleTeamUpdated = (newTeam) => {
    handleTeamSelect(newTeam)();
  };

  const handleTeamCreated = (newTeam) => {
    openTeamImportModal(false)();
    openTeamCreateModal(false)();
    handleTeamSelect(newTeam)();
  };

  const handleTeamSelect = (targetTeam) => () => {
    setSelectedTeam(targetTeam.name);
    setModalTeam(targetTeam);
  };

  const handleCancelTeamSelect = () => {
    setModalTeam(getModalTeamInitState());
    setSelectedTeam('');
  };

  return (
    <SectionDiv>
      <StyledDiv>
        <div className="teams-panel">
          <div className="teams-panel--start">{`${Multilingual(`TOURNAMENT.TEAM_AMOUNT`)}：${teams.length}`}</div>
          <div className="teams-panel--end">
            <Button width="unset" color="transparentWithBorder" onClick={openTeamImportModal(true)}>
              {Multilingual(`TOURNAMENT.IMPORT_FROM_TOURNAMENT.WORDING`)}
            </Button>
            <Button width="unset" color="transparentWithBorder" onClick={openTeamCreateModal(true)}>
              {Multilingual(`COMMON.CREATE`)}
            </Button>
          </div>
        </div>
        <div className="team-list">
          {teams.map((team) => (
            <label key={team.name} className="team" onClick={handleTeamSelect(team)}>
              {team.name}
            </label>
          ))}
        </div>
      </StyledDiv>
      <TeamModal
        selectedTeam={selectedTeam}
        handleCancelTeamSelect={handleCancelTeamSelect}
        modalTeam={modalTeam}
        teamUpdated={handleTeamUpdated}
      />
      <CreateTeamModal isOpen={isTeamCreating} toClose={openTeamCreateModal(false)} created={handleTeamCreated} />
      <ImportTeamModal isOpen={isTeamImporting} toClose={openTeamImportModal(false)} created={handleTeamCreated} />
    </SectionDiv>
  );
};

export default Teams;
